import { get } from './axios.js'

let api = '/api'

export const getTopicInfo = query => get(api + '/getSubjectDetail?' + (query || ''))
export const getTopicNews = query => get(api + '/getSubjectRelationList?' + (query || ''))
